export default __webpack_public_path__ + "static/media/36I-120775_-43981_0.943f12d2.jpg";